import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '../generic/service/http.service';
import { Logger } from '../generic/logging/default-log.service';
import { BaseService } from '../generic/service/base.service';
import { ConfigurationHelper } from '../generic/helper/configuration.helper';
import { HunterIntro } from '../components/hunters/hunter.intro';

/**
 * Responsible for getting Hunters overview data.
 *
 * @author Patrick van Zadel
 */
@Injectable()
export class HuntersService extends BaseService {
    private http = inject(HttpClient);

    private huntersBaseUrl = '/rest/hunters';
    private huntersBannerUrl = `${this.huntersBaseUrl}/banner`;
    private huntersIntroUrl = `${this.huntersBaseUrl}/intro`;

    constructor() {
        const logger = inject(Logger);

        super(logger);
    }

    /**
     * Get the hunter overview banner item
     */
    public getHuntersBanner(): Promise<string> {
        return lastValueFrom(
            this.http.getText(ConfigurationHelper.getWebshopUrl(this.huntersBannerUrl)),
        );
    }

    /**
     * Get the hunter overview intro text.
     * @param blogId
     */
    public getHuntersIntro(): Promise<HunterIntro[]> {
        return lastValueFrom(
            this.http.get<HunterIntro[]>(ConfigurationHelper.getWebshopUrl(this.huntersIntroUrl)),
        );
    }
}
